import axios from 'axios'
import {resetAuth, setAuth} from './../../utils/auth'
import {API_SERVER, BASE_URL, AUTHORIZATION} from './../../constants/constants'

const state = {
  user: null,
  currentToken: localStorage.getItem(AUTHORIZATION)
}
const mutations = {
  setAuth (state, data) {
    state.currentToken = data
  },
  setUser (state, data) {
    state.user = data
  },
  resetUser (state) {
    state.user = null
    state.currentToken = null
  }
}
const actions = {
  async fetch ({commit, dispatch}, param) {
    if (!param) {
      return
    }
    let {data} = await axios({
      url: 'member/fetch-me',
      headers: {'X-AUTH-TOKEN': param},
      baseURL: API_SERVER + BASE_URL
    })
    if (data && data.status === 200) {
      const user = {
        id: data.data.id,
        firstName: data.data.firstName,
        lastName: data.data.lastName,
        roleCode: data.data.roleCode,
        organizationId: data.data.organizationId,
        organizationInn: data.data.organizationInn,
        organizationName: data.data.organizationName
      }
      commit('setUser', user)
      commit('setAuth', param)
      setAuth(param)
    } else {
      dispatch('resetAuth')
    }
    return data
  },
  login ({commit}, param) {
    return axios.post('auth/login', param)
      .then(response => {
        const {data} = response
        if (data && data.status === 200) {
          commit('setAuth', data.data.currentToken)
          setAuth(data.data.currentToken)
        }
        return response
      })
  },
  logout ({ commit }) {
    return axios.get('auth/logout')
      .then(response => {
        commit('resetUser')
        resetAuth()
        return response.data.status
      })
  },
  resetAuth ({commit}) {
    commit('resetUser')
    resetAuth()
  }
}
const getters = {
  currentToken: (state) => {
    return state.currentToken
  },
  getUser: (state) => {
    return state.user
  },
  getOrganizationId: (state) => {
    return state.user && state.user.organizationId
  },
  getOrganizationName: (state) => {
    return state.user && state.user.organizationName
  },
  getOrganizationInn: (state) => {
    return state.user && state.user.organizationInn
  },
  isSuperAdmin: (state) => {
    return state.user && state.user.roleCode === 'SUPER_ADMIN'
  },
  isModerator: (state) => {
    return state.user && state.user.roleCode === 'MODERATOR'
  },
  isOperator: (state) => {
    return state.user && state.user.roleCode === 'OPERATOR'
  },
  isScanner: (state) => {
    return state.user && state.user.roleCode === 'SCANNER'
  },
  isTaxInspector: (state) => {
    return state.user && state.user.roleCode === 'TAX_INSPECTOR'
  },
  isOrganizationUser: (state) => {
    return state.user && state.user.roleCode === 'OPERATOR'
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js